




















import { defineComponent, onMounted } from '@vue/composition-api';
import { ArrowRightIcon } from '@tencent/wphk-icon-vue';
import { LinkedOIcon, BillOIcon } from '@tencent/wphk-icon-vue/applehub';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import Banner from './banner.vue';
import { useAppleDpBanner } from './use-dp-banner';
import { biBrow, biClick } from '@tencent/fit-bi-sdk';

const APPLE_PLAN_ID = '32001023267050000001';
/** 跳转adtag */
const ADTAG = 'discount_center';

export default defineComponent({
  name: 'AppleHubCard',
  components: {
    ArrowRightIcon,
    LinkedOIcon,
    BillOIcon,
    Banner,
  },
  setup() {
    const { bannerInfo, initBanner } = useAppleDpBanner();
    const onClickCard = () => {
      biClick('apple_hub_card.index');
      jumpPage.goAppleHub({ adtag: ADTAG });
    };
    const onClickManage = () => {
      biClick('apple_hub_card.manage_btn');
      jumpPage.goAppleContractList({
        adtag: ADTAG,
        params: {
          bindSource: jumpPage.JumpAppleContractSource.AppleHub,
        },
      });
    };
    const onClickRecord = () => {
      biClick('apple_hub_card.record_btn');
      jumpPage.goTradeRecord({
        adtag: ADTAG,
        params: {
          planId: APPLE_PLAN_ID,
        },
      });
    };
    onMounted(() => {
      initBanner();
      biBrow('apple_hub_card.index');
    });
    return {
      bannerInfo,
      onClickCard,
      onClickManage,
      onClickRecord,
    };
  },
});
